import React, { Component } from 'react';
import { isMobileOnly } from "react-device-detect";
import { ArrayUtils, StringUtils } from '../utils';
import { History as history, Routes as routes } from '../navigation';
import { Header, Line } from '../components';
import '../css/SignIn.css';

class ProviderInvitesSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      invites: [],
    }
  }

  componentDidMount() {
    let token = this.props.token;
    this.props.userActions.getPracticeJoinInvites(token, this.setInvitesArray);
  }

  renderProviderInvites = () => {
    let invites = this.state.invites || [];

    if (invites.length === 0) {
      return null;
    }

    let invite_rows = invites.map((invite, index) => {
      let practice_info = ArrayUtils.getSingleObject(invite.practice);
      let practice_name = StringUtils.displayName(practice_info);
      let is_last       = index === invites.length -1;

      return <div key={index} className='flex-container-column'>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: 'grey', fontSize: 13 }}>{ practice_name }</span>

          <div className='flex-container-row'>
            <span className='instant-cancel-button'
                  style={{ marginRight: 10 }}
                  onClick={ () => {
                    let token = this.props.token;
                    this.props.userActions.updateInvite(token, invite, false, false, this.inviteCallback);
                  }}>
                  <span style={{ fontSize: 13, color: '#1dc2ff' }}>Decline</span>
            </span>

            <span className='instant-join-session-button'
                  style={{ marginRight: 10 }}
                  onClick={ () => {
                    let token = this.props.token;
                    let is_initial_fetch = this.props.initialFetch;
                    this.props.userActions.updateInvite(token, invite, true, is_initial_fetch, this.inviteCallback);
                  }}>
                  <span style={{ fontSize: 13, color: 'white' }}>Accept</span>
            </span>
          </div>
        </div>
        <Line hide={is_last} style={{ marginTop: 15, marginBottom: 15, backgroundColor: '#f3f3f3' }} />
      </div>
    }).filter((row) => { return row });

    let width = isMobileOnly ? 300 : '';

    return <div className="standard-container" style={{ width: width, minWidth: width, maxWidth: width }}>
      <Header title='Practice Invite Requests' icon='fas fa-envelope' />
      <div style={{ padding: 15 }}>
        { invite_rows }
      </div>
    </div>
  }

  render() {
    return this.renderProviderInvites();
  }

  inviteCallback = () => {
    let token = this.props.token;
    this.props.userActions.getPracticeJoinInvites(token, this.setInvitesArray);
  }

  setInvitesArray = (invites_array) => {
    this.setState({ ...this.state, invites: invites_array });
  }

}

export default ProviderInvitesSection
